<div class="row">
  <div class="col">
    <mat-checkbox
      [checked]=!initialComboProduct.isHidden
      [disabled]="!canEdit || !allowOverrides"
      type="checkbox"
      (change)="changeIsHidden($event)"
    >
    </mat-checkbox>
  </div>
  <div class="col" style="flex: 3">
    <span>
      {{ getProductName(externalComboGroupId, comboProductStructure.externalProductId) }}
    </span>
    <span *ngIf="comboProductStructure.sizeId">
      ({{ getSizeName(comboProductStructure.sizeId) }})
    </span>
  </div>
  <div class="col">
    <span *ngIf="!canEdit; else priceInput" [class.isDifferent]="isProductPriceDifferent()">
      {{ comboProductStructure.price }} {{ currency }}
    </span>
    <ng-template #priceInput>
      <input value="{{comboProductStructure.price}}"
             (change)="changePrice($event)"
             [class.isDifferent]="isProductPriceDifferent()"
             class="modifier-input input-number"
             type="number"
             [readonly]="!allowOverrides"
             (blur)="onChangeInformationMessage()">
    </ng-template>
  </div>
  <div class="col">
    <mat-icon *ngIf="!isSavingMode && allowOverrides"
      (click)="editMode()"
      class="edit-icon"
      color=""
      matTooltip="{{ editComboIconTooltip }}"
      matTooltipPosition="above">{{ canEdit ? 'save' : 'edit' }}
    </mat-icon>

    <mat-icon *ngIf="!isSavingMode && allowOverrides"
      (click)="editProduct()"
      class="edit-icon"
      color=""
      matTooltip="{{ editComboProductIconTooltip }}"
      matTooltipPosition="above">{{ 'edit' }}
    </mat-icon>

    <mat-spinner *ngIf="isSavingMode" [diameter]="20"></mat-spinner>
  </div>
</div>
